import { render, staticRenderFns } from "./customCss.vue?vue&type=template&id=6a2fbf02&scoped=true"
import script from "./customCss.vue?vue&type=script&lang=js"
export * from "./customCss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2fbf02",
  null
  
)

export default component.exports